import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { Leaderboard, LeaderboardPeriod, UserGamification } from '../../models/gamification.model';

@Injectable({ providedIn: 'root' })
export class GamificationService {
  private readonly api = inject(ApiService);

  getMyStats(): Observable<UserGamification> {
    return this.api.get<UserGamification>('/api/gamification/me');
  }

  getLeaderboard(period: LeaderboardPeriod = 'week', page = 1): Observable<Leaderboard> {
    return this.api.get<Leaderboard>('/api/gamification/leaderboard', { period, page });
  }
}
